import styled, { css } from 'styled-components';
export const Container = styled.li`
  display: flex;
  width: 100%;
  gap: 1rem;
  padding: .5rem;
  align-items: center;
  background-color: #ffffff;
  border-radius: 4px 0 0 4px;
  border-bottom: solid 1px #dadce0;
  /* border-left: solid 6px rgb(251,75,75);
  .userAvt {
    background-color: rgb(251,75,75) ;
  }
  ${({ statusUser }) =>
    (statusUser === 'S') &&
    css`
      border-left-color: #1D86FF;
      .userAvt {
        background-color: #1D86FF
      }
    `
  } */
`;
export const Content = styled.div`
  display: flex;
  width: calc(100% - 3rem);
  height: 100%;
  > div:nth-child(1){
    display: flex;
    width: calc(100% - 3rem);
    min-height: 5rem;
    flex-direction: row;
    > div:nth-child(1){
      display: flex;
      width: 60%;
      height: 100%;
      flex-direction: column;
      > span{
        display: flex;
        height: 33%;
        align-items: center;
        gap: .5rem;
      }
      .title{
        font-size: 1.2rem;
        font-weight: 500;
        color: black;
      }
      .subtitle{
        color: #6c757d;
      }
    }
    > div:nth-child(2){
      width: 40%;
      border-left: 2px solid #ecedef;
      padding-left: 10px;
    }
  }
  > div:nth-child(2){
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    min-height: 100%;
    cursor: pointer;
    > span {
      display: flex;
      width: 3rem;
      height: 3rem;
      justify-content: center;
      align-items: center;
      background: #ecedef;
      border-radius: 6px;
      &:hover{
        opacity: 0.9;
      }
      > .user-settings {
        font-size: 1.5rem;
        color: #1D86FF;
      }
    }
  }
`;
export const AccessLevelInfo = styled.ul`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: left;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  > li {
    display: flex;
    min-width: 3rem;
    align-items: center;
    padding: 0.3rem;
    color: #ffffff;
    font-size: 12px;
    font-weight: bolder;
    text-align: center;
    justify-content: center;
    border-radius: 4px;
    background-color:#1D86FF; 
  }
`;